import React from 'react';

const format = (digits) => {
  const d = digits.replace(/\D/g, '').slice(0, 9);
  let r = '';
  if (d.length > 0) r += d.slice(0, 2);
  if (d.length > 2) r += ' ' + d.slice(2, 5);
  if (d.length > 5) r += ' ' + d.slice(5, 7);
  if (d.length > 7) r += ' ' + d.slice(7, 9);
  return r;
};

const extract = (val) => {
  if (!val) return '';
  return val.replace(/^\+998\s?/, '').replace(/\D/g, '');
};

// value: full phone string e.g. "+998 90 123 45 67"
// onChange: called with full string "+998 XX XXX XX XX"
// style: applied to the outer wrapper div (should match your input style)
const PhoneInput = ({ value, onChange, style, hasError, required }) => {
  const digits = extract(value);
  const displayed = format(digits);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 9);
    const formatted = format(raw);
    onChange(formatted ? '+998 ' + formatted : '+998 ');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace' && !digits) e.preventDefault();
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center',
      border: `1px solid ${hasError ? '#e53e3e' : '#e2e8f0'}`,
      borderRadius: '8px',
      backgroundColor: 'white',
      overflow: 'hidden',
      ...style,
      padding: 0,
    }}>
      <span style={{
        padding: '0 0 0 1rem',
        fontSize: '1rem',
        color: '#2d3748',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        flexShrink: 0,
      }}>+998</span>
      <input
        type="tel"
        value={displayed}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="XX XXX XX XX"
        required={required}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          padding: '0.75rem 1rem 0.75rem 0.35rem',
          fontSize: '1rem',
          backgroundColor: 'transparent',
          color: '#2d3748',
          minWidth: 0,
        }}
      />
    </div>
  );
};

export default PhoneInput;
